export default __webpack_public_path__ + "static/media/service-2.2c95a866.svg";